import type { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { SESSION_KEY } from '../const'

const apiClientMainServiceMiddleware = (apiClient: AxiosInstance): AxiosInstance => {
  const requestHandler = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
    const token = localStorage.getItem(SESSION_KEY)
    if (token) {
      config.headers = {
        ...(config.headers || {}),
        authorization: `Bearer ${token}`,
      }
    }
    return config
  }

  const responseFulfilledHandler = async (response: AxiosResponse): Promise<AxiosResponse> => {
    return response
  }
  const responseRejectedHandler = async (err: AxiosError): Promise<AxiosError | AxiosResponse> => {
    return Promise.reject(err)
  }

  apiClient.interceptors.request.use(requestHandler)
  apiClient.interceptors.response.use(responseFulfilledHandler, responseRejectedHandler)
  return apiClient
}

export { apiClientMainServiceMiddleware }
